import style from './style.module.css';
import { Col, Select } from 'fave-ui';
import { PageHeaderWithBackButton } from '../../../components/common/PageHeaderWithBackButton';
import { useState } from 'react';
import {
  FunderType,
  useFetchCashbackCampaignOptions,
} from '../../../services/CashbackCampaign/useFetchFLPCashbackListing';
import FlpCampaignForm from './FlpCampaignForm';
import ECardCampaignForm from './ECardCampaignForm';
import FaveCashbackCampaign from './FaveCampaignForm';

export default function NewCashbackCampaign() {
  const [campaignType, setCampaignType] = useState<FunderType['value']>();

  const { data: optionsData } = useFetchCashbackCampaignOptions({});

  const cashbackCampaignTypes = optionsData?.funder_types?.map(item => {
    return { label: item.campaign_type, value: item.value, key: item.value };
  });

  return (
    <>
      <PageHeaderWithBackButton title={`Create Cashback Campaign`} />

      <div className="mb-4">
        <p className={style.section}>1. Campaign Type</p>
        <Col span={24} className="mt-2">
          <Select
            placeholder="Please Select one option"
            options={cashbackCampaignTypes}
            onSelect={setCampaignType}
          />
        </Col>
      </div>

      {campaignType === 'Flp::Client' && <FlpCampaignForm />}

      {campaignType === 'BKE::ECard' && <ECardCampaignForm />}

      {campaignType === 'Fave' && <FaveCashbackCampaign />}
    </>
  );
}
